import { c as _c } from "react/compiler-runtime";
const TermsModalContent = () => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="mb-4 font-medium text-xl">{"Store Policies & Terms of Use"}</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-2">Please review our Privacy Policy for details on how we collect, use, and protect your personal information.</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Your Account</h4>You are responsible for maintaining the confidentiality of your account credentials and for restricting access to your devices. You agree to accept responsibility for all activity that occurs under your account. Users under the age of 18 may access hivemodern.com only with the involvement of a parent or guardian. Hive reserves the right to refuse service, terminate accounts, remove or edit content, or cancel orders at its discretion.</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Order Status</h4>Log in with your email address and password to view order history, print receipts, and access tracking information and order details. If you need help locating anything, we're happy to assist.</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Sales Tax</h4>hive is located in Oregon, a sales-tax-free state, and collects sales tax only when required by law. Please check your shopping cart at checkout or give us a call if you have questions.</div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Shipping</h4>hive offers free shipping whenever possible, and we make every effort to ship all orders within two business days of purchase unless otherwise noted. Delivery estimates are provided in good faith, though they are not guaranteed. hive is not liable for delays in shipment or delivery. Please note that we are unable to ship to P.O. boxes.</div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Returns</h4>We want you to be happy with your purchase. Merchandise may be returned for store credit or exchange within 30 days of delivery, provided the item is in its original condition and packaging and accompanied by the original receipt. All returns must be pre-authorized — please call us at (503) 242-1967 before sending anything back. Returns received without prior authorization are subject to a 20% restocking fee.</div>;
    t7 = <div className="mb-2">Please note that the following items are not eligible for return: non-stock items, special orders, lighting, and polycarbonate items. Refunds are not issued except in cases of defective merchandise that we are unable to replace.</div>;
    t8 = <div className="mb-2">Returns should be carefully packed and shipped at the customer's expense to: hive, 820 NW Glisan Street, Portland, OR 97209.</div>;
    t9 = <div className="mb-2">Original outbound shipping costs are non-refundable. Store credit is valid for one year from the date of issue; unused credit is forfeited thereafter.</div>;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Damaged or Defective Items</h4>We ask that you inspect all items promptly upon delivery. Claims for damaged or defective merchandise must be filed within 24 hours of delivery, as claims received after this window generally cannot be processed.</div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Order Cancellation</h4>Orders cancelled after 24 hours may be subject to a cancellation and restocking fee of 25–50% of the order value, in addition to any shipping charges already incurred.</div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">{"Changes to Terms & Site"}</h4>Hive reserves the right to modify these terms of use at any time, with or without prior notice.</div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">User Warranties</h4>By placing an order, you confirm that you are 18 years of age or older, that the information you have provided is accurate and complete, and that you have the authority to place the order.</div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Disclaimer of Warranties</h4>Your use of this site is at your sole risk. hivemodern.com is provided on an "as is" and "as available" basis. Hive makes no representations or warranties of any kind, express or implied, regarding the operation of this site or the information, content, materials, or products available through it.</div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="mb-2"><h4 className="block font-medium text-sm my-2">Indemnification</h4>You agree to indemnify and hold harmless hive, hivemodern.com, and its officers, directors, employees, and suppliers from any claim, demand, action, or damage — including reasonable attorneys' fees — arising out of or related to your use of this site.</div>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <>{t0}<section className="w-full text-xs">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}<div className="mb-2"><h4 className="block font-medium text-sm my-2">Termination</h4>hive reserves the right to terminate your account and restrict access to this site if we have reason to believe you have violated any of these terms, including providing false or inaccurate information.</div></section></>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  return t16;
};
export default TermsModalContent;